import { ChatText, UsersThree } from "@phosphor-icons/react";

/**
 * Inline tab strip shown at the top of the Messages panel's left rail.
 * Lives INSIDE the SmsPanel / TeamChatPanel so it stays visually anchored
 * to the conversation list rather than fighting with the page header / bell.
 */
export default function MessagesTabStrip({ tab, smsUnread, teamUnread, onChange }) {
  return (
    <div className="grid grid-cols-2 border-b border-[var(--border)] bg-[var(--bg-sidebar)] shrink-0" data-testid="messages-tabs">
      <button
        onClick={() => onChange("sms")}
        className={`relative px-3 py-3 text-[13px] font-bold flex items-center justify-center gap-1.5 border-b-2 transition-all ${
          tab === "sms"
            ? "border-[var(--accent)] text-[var(--accent)] bg-white shadow-[inset_0_-3px_0_var(--accent)]"
            : "border-transparent text-[var(--text-muted)] hover:text-[var(--text-primary)] hover:bg-white/60"
        }`}
        data-testid="tab-sms"
      >
        <ChatText size={14} weight={tab === "sms" ? "fill" : "regular"} /> Customer SMS
        {smsUnread > 0 && (
          <span
            className="ml-0.5 min-w-[16px] h-[16px] px-1 text-[10px] font-bold rounded-full flex items-center justify-center bg-red-500 text-white"
            data-testid="tab-sms-badge"
          >
            {smsUnread > 99 ? "99+" : smsUnread}
          </span>
        )}
      </button>
      <button
        onClick={() => onChange("team")}
        className={`relative px-3 py-3 text-[13px] font-bold flex items-center justify-center gap-1.5 border-b-2 border-l border-l-[var(--border)] transition-all ${
          tab === "team"
            ? "border-b-[var(--accent)] text-[var(--accent)] bg-white shadow-[inset_0_-3px_0_var(--accent)]"
            : "border-b-transparent text-[var(--text-muted)] hover:text-[var(--text-primary)] hover:bg-white/60"
        }`}
        data-testid="tab-team"
      >
        <UsersThree size={14} weight={tab === "team" ? "fill" : "regular"} /> Team Chat
        {teamUnread > 0 && (
          <span
            className="ml-0.5 min-w-[16px] h-[16px] px-1 text-[10px] font-bold rounded-full flex items-center justify-center bg-red-500 text-white"
            data-testid="tab-team-badge"
          >
            {teamUnread > 99 ? "99+" : teamUnread}
          </span>
        )}
      </button>
    </div>
  );
}
